import { SVGProps } from 'react'

const ImageIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5889 0.400391L13.0791 2.3916V16.3662H0.400391V0.400391H10.5889Z"
        fill="white"
        stroke="#969492"
        strokeWidth="0.8"
      />
      <path
        d="M11.0471 1.24688L12.4055 2.34684L10.9826 2.73495L11.0471 1.24688Z"
        fill="white"
        stroke="#969492"
      />
      <rect
        x="2.27509"
        y="4"
        width="9.07801"
        height="9.07802"
        rx="1.5"
        fill="url(#paint0_linear_4918_1074)"
      />
      <ellipse
        cx="9.89861"
        cy="6.06316"
        rx="0.962819"
        ry="0.96282"
        fill="#EAF0F5"
      />
      <path
        d="M5.45666 7.79138C6.03938 6.90015 7.33928 6.88294 7.9454 7.75844L9.99863 10.7242C10.6874 11.7191 9.97533 13.078 8.76534 13.078H4.77295C3.58096 13.078 2.86518 11.7548 3.51749 10.7572L5.45666 7.79138Z"
        fill="#47D4FF"
      />
      <path
        d="M6.68136 9.39514C7.27082 8.52001 8.55567 8.51087 9.15751 9.37753L10.0914 10.7224C10.7822 11.7171 10.0704 13.078 8.8594 13.078H7.01959C5.8183 13.078 5.10438 11.7364 5.77549 10.74L6.68136 9.39514Z"
        fill="#0E8EE7"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4918_1074"
          x1="6.81409"
          y1="4"
          x2="6.81409"
          y2="13.078"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C7FCF" />
          <stop offset="1" stopColor="#6767C1" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default ImageIcon
